import React, { FC } from 'react'
import ScreenLayout from 'components/ScreenLayout'
import AuthCallbackGoogle from 'components/AuthCallbackGoogle'

const AuthCallbackGoogleScreen: FC = () => (
  <ScreenLayout disableModal>
    <AuthCallbackGoogle />
  </ScreenLayout>
)

export default AuthCallbackGoogleScreen